<template>
  <v-dialog
    v-model="dialog"
    :width="!showDone? '510px': '330px'">
    <div class="dialog-container">
      <h3>{{ title }}</h3>
    
      <p v-if="dialogType === 0">The endorsement quote has been delivered to the user account.</p>
      <p v-else-if="dialogType === 2">This endorsement has been completed.</p>
      <p v-else-if="showCheque">This endorsement has been completed. The refund amount has been added to the cheque queue.</p>
      <p v-else-if="showCredits">This endorsement has been completed. The refund amount has been added to the customer’s credits.</p>
      <p v-else-if="!showDone">Do you want to refund via cheque, or add to the customer’s credits?</p>

      <div
        v-if="!showDone"
        class="dialog-footer">
        <v-button @click="dialog = false">Cancel</v-button>
        <v-button
          type="primary"
          @click="handlerCheque">Cheque</v-button>
        <v-button
          type="primary"
          @click="handlerCredits">Credits</v-button>
      </div>
      <div v-else>
        <v-button
          type="primary"
          @click="handlerDone">Done</v-button>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import { deliverEndorsement, saveCancelQuote } from '@/api/endorsement'
export default {
  name: 'DeliverDialog',
  props: {
    dialogType: {
      type: Number,
      default: 0
    },
    diffPayble: {
      type: Number,
      default: 0
    },
    submitFormData: {
      type: Object,
      default: () => ({})
    },
    cancelParams: {
      type: Object,
      default: () => ({})
    },
    isCancel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false,
      //   dialogType: 0, // normal、refund、no difference
      refundType: 0, // 1-cheque, 2-credits
    }
  },
  computed: {
    title() {
      return this.showDone? 'Endorsement': 'Refund'
    },
    showCheque() {
      return (this.dialogType === 1 && this.refundType === 1)
    },
    showCredits() {
      return (this.dialogType === 1 && this.refundType === 2)
    },
    showDone() {
      if(this.dialogType !== 1) {
        return true
      }
      if(this.dialogType === 1 && this.refundType !== 0) {
        return true
      }
      return false
    }
  },
  methods: {
    changeDialog() {
      this.dialog = !this.dialog
      // 初始化
      this.refundType = 0 
    },
    handlerDone() {
      this.$emit('done')
      this.dialog = false
    },
    handlerCheque() {
      // this.refundType = 1
      if(this.isCancel) {
        this.network().saveCancelQuote(1)
      }
      else {
        this.network().deliverEndorsement(1)
      }
    },
    handlerCredits() {
      // this.refundType = 2
      if(this.isCancel) {
        this.network().saveCancelQuote(2)
      }
      else {
        this.network().deliverEndorsement(2)
      }
    },
    network() {
      return {
        deliverEndorsement: async (refundType) => {
          const { data } = await deliverEndorsement({
            ...this.submitFormData,
            refund_type: refundType
          })
          this.refundType = refundType
        },
        saveCancelQuote: async (refundType) => {
          const { data } = await saveCancelQuote({
            type: 2,
            refund_type: refundType,
            ...this.cancelParams,
          })
          this.refundType = refundType
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
      padding: 15px;
      h3 {
        padding-bottom: 5px;
      }
      p {
        padding-bottom: 10px;
        font-size: 16px;
        color: #616266;
      }
      .dialog-footer {
        margin: 15px -15px -15px;
        padding: 15px;
        text-align: right;
        background: #F9FAFB;
      }
    }
</style>